import {useLoaderData, Link} from 'react-router-dom';
import React, { useEffect, useRef, useState } from "react";
import { getPeople, initialiseBaseSkins, blockUser, unblockUser } from '../Users'
import { useUser } from "../components/UserContext";
import PersonIcon from '@mui/icons-material/Person';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BlockIcon from '@mui/icons-material/Block';

export async function loader({params}) {
    const userId = params.userId;
    const {people, blockedPeople} = await getPeople(userId);
    return {people, blockedPeople};
}

export default function People() {
    const {people, blockedPeople} = useLoaderData();
    const {currentUser} = useUser();
    const menuRef = useRef(null);
    const [isClicked, setClicked] = useState(false);
    const [totals, setTotals] = useState({people: [], blockedPeople: []})

    useEffect(() => {
        document.title = `people`;
        initialiseBaseSkins(currentUser.id);
    }, [currentUser.id]);

    useEffect(() => {
        if (people.length > 0 || blockedPeople.length > 0) {
            setTotals({ people: [...people], blockedPeople: [...blockedPeople]})
        }
    }, [people, blockedPeople])

    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setClicked(false);
            }
        }
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    function handleBlockClick(id) {
        blockUser(currentUser.id, id);
        setTotals((prev) => {
            const updatedTotal = {...prev};
            const blockedUser = updatedTotal.people.find((item) => item.id === id);
            updatedTotal.people = updatedTotal.people.filter((item) => item.id !== id);
            updatedTotal.blockedPeople.push(blockedUser);
            return updatedTotal;
        })
    }

    function handleUnblockClick(id) {
        unblockUser(currentUser.id, id);
        setTotals((prev) => {
            const updatedTotal = {...prev};
            const unblockedUser = updatedTotal.blockedPeople.find((item) => item.id === id);
            updatedTotal.blockedPeople = updatedTotal.blockedPeople.filter((item) => item.id !== id);
            updatedTotal.people.push(unblockedUser);
            return updatedTotal;
        })
    }

    return(
        <div>
            <div className="page-head" style={{height:"175px"}}>
                <div className="page-title settings-title">
                    <div className="creator-pfp">
                        </div>
                    <h2 className="title-text">people</h2>
                </div>
            </div>
            <div>
                <div id="people-display">
                    {totals.people.map((item, index) => {
                    return (
                        <div className="people-item" key={`${index}-${item.username}-person`}>
                            <Link to={`/profile/${item.id}`} className="people-item-content">
                                {item.pfp? <img className="people-item-image" src={item.pfp} alt="mock pfp" />
                                : <div className="people-item-image"><PersonIcon className="people-item-default-image"/></div>
                                }
                                <h4>{item.username}</h4>
                            </Link>
                            {item.id !== currentUser.id && 
                                <div ref={isClicked === item.id ? menuRef : null} className="people-options-container">
                                    <MoreVertIcon onClick={() => {setClicked((prev) => prev === item.id? false : item.id)}}/>
                                    {isClicked === item.id && 
                                        <div className="people-menu" onClick={() => 
                                            {setClicked(false);handleBlockClick(item.id)}}
                                        >
                                            <BlockIcon sx={{fontSize: "20px"}}/> 
                                            <p>block</p>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                        )
                    })}
                </div>
                
                {totals.blockedPeople.length > 0 && <h3 className="subtitle-text">blocked people</h3>}
                {totals.blockedPeople.length > 0 && <div id="blocked-people-display">
                    {totals.blockedPeople.map((item, index) => {
                    return (
                        <div className="people-item" key={`${index}-${item.username}-person`}>
                            <div className="people-item-content">
                                {item.pfp? <img className="people-item-image" src={item.pfp} alt="mock pfp" />
                                : <div className="people-item-image"><PersonIcon className="people-item-default-image"/></div>
                                }
                                <h4>{item.username}</h4>
                            </div>
                                <div ref={isClicked === item.id ? menuRef : null} className="people-options-container">
                                    <MoreVertIcon onClick={() => {setClicked((prev) => prev === item.id? false : item.id)}}/>
                                    {isClicked === item.id && 
                                        <div className="people-menu" onClick={() => 
                                            {setClicked(false);handleUnblockClick(item.id)}}
                                        >
                                            <BlockIcon sx={{fontSize: "20px"}}/> 
                                            <p>unblock</p>
                                        </div>
                                    }
                                </div>
                        </div>
                        )
                    })}
                </div>}
            </div>
        </div>
    )
}